import { useEffect } from 'react';
import { useWSEvent } from '../contexts/WebSocketContext';
import { toast } from 'sonner';

/**
 * Global component that listens to WebSocket events and shows toast notifications.
 * Place this inside the WebSocketProvider.
 */
const RealtimeToastListener = () => {
  // New chat message
  useWSEvent('chat_message', (event) => {
    const d = event.data || {};
    toast.info(`${d.sender_name || 'Someone'}: ${(d.message || '').substring(0, 60)}`, {
      duration: 4000,
    });
  });

  // Notification
  useWSEvent('notification', (event) => {
    const d = event.data || {};
    toast(d.title || 'New notification', {
      description: d.message || '',
      duration: 5000,
    });
  });

  // Bid update
  useWSEvent('bid_update', (event) => {
    const evt = event.event;
    const d = event.data || {};
    if (evt === 'bid_accepted') {
      toast.success(`Bid accepted on "${d.job_title}"!`, { duration: 6000 });
    } else if (evt === 'bid_rejected') {
      toast.error(`Bid not selected on "${d.job_title}"`, { duration: 5000 });
    } else if (evt === 'new_bid') {
      toast.info(`New bid on "${d.job_title}"`, { duration: 5000 });
    }
  });

  // Badge update - dispatch event for Navbar to consume
  useWSEvent('badge_update', (event) => {
    window.dispatchEvent(new Event('refreshBadgeCounts'));
  });

  return null;
};

export default RealtimeToastListener;
